<template>
    <v-container
            class="fill-height"
            fluid
    >
        <v-row
                align="center"
                justify="end"
        >
            <v-col
                    cols="12"
                    sm="8"
                    md="4"
            >
                <v-card class="elevation-12">
                    <v-card-text>


                        <v-container>
                            <v-row class="header-image-container">
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <v-img
                                            src="./../assets/logo.jpg"
                                            lazy-src="./../assets/logo.jpg"
                                            class="grey lighten-2"
                                            max-width="250"
                                    ></v-img>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <p class="text-justify font-weight-bold">
                                        {{ $t('registerSuccess.header') }}
                                    </p>
                                    <p class="text-justify">
                                        {{ $t('registerSuccess.text') }}
                                    </p>
                                    <a target="_blank"
                                       href="https://play.google.com/store/apps/details?id=com.phonegap.sharesuite&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                                       style="display: inline-block; overflow: hidden; background: url(&quot;https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png&quot;) center center no-repeat; width: 9.75rem; height: 4.33rem; background-size:contain; "></a>
                                    <a target="_blank"
                                       href="https://itunes.apple.com/us/app/sharesuite/id1100115414?mt=8"
                                       style="display: inline-block; overflow: hidden; background: url(&quot;https://linkmaker.itunes.apple.com/de-de/badge-lrg.svg?releaseDate=2016-09-11&amp;kind=iossoftware&amp;bubble=ios_apps&quot;) center center no-repeat; width: 9.75rem; height: 4.33rem;"></a>
                                </v-col>
                            </v-row>
                            <v-row
                            >
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <v-btn x-large color="success" class="go-button" @click="go">
                                        {{ $t('registerSuccess.go') }}
                                    </v-btn>

                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: 'RegisterSuccess',

        methods: {
            go() {
                location.replace(location.origin + "/" + process.env.VUE_APP_WEB_APP_PATH);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .header-image-container {
        height: 75px;
    }

    .go-button {
        width: 100%;
        text-transform: initial;
    }
</style>
